module.exports = __webpack_public_path__ + "img/avatar5.c9dfd973.png";